export const FOR_TEACHERS = 1;
export const FOR_KIDS = 2;